import Vue from 'vue'
import Vuex from 'vuex'
import qa from './stores/qa'

Vue.use(Vuex)


export default new Vuex.Store({
  modules: {
    qa
  },
  state: {
    dsAccepted: true
  },
  mutations: {
    SET_DS_ACCEPTED:  (state,answer) => {
      state.dsAccepted = answer;
    }
  },
  actions: {

  },
  getters: {
    getDsAccepted: (state) => {
      return state.dsAccepted;
    }
  }
})
